module.exports = __webpack_public_path__ + "img/withdrawn.4edcb3aa.svg";